var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bead",class:{'bead-five': _vm.beadtype=='heavenly', 'bead-kid': _vm.kidColors, 'bead-five-kid': _vm.kidColors&&_vm.beadtype=='heavenly'}})}
var staticRenderFns = []

export { render, staticRenderFns }